import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { RegistroPersonasEmpresasLibModule } from "@rpe/registro-personas-empresas-lib";
import { SharedModule } from '../../shared/shared.module';
import { NavegacionRoutingModule } from "./navegacion-routing.module";
import { PrincipalComponent } from "./principal/principal.component";
import { LandingComponent } from "./landing/landing.component";
import { UbicacionesModule } from "../ubicaciones/ubicaciones.module";

@NgModule({
  declarations: [
    PrincipalComponent,
    LandingComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    SharedModule,    
    RegistroPersonasEmpresasLibModule,
    UbicacionesModule, 
    NavegacionRoutingModule
  ],
  exports: [
    PrincipalComponent,
    LandingComponent
  ]
})
export class NavegacionModule {}
